import { define } from './define';

// Names of things the API sends as codes: states, networks, roles, outcomes. Looked up with tMaybe(`state.${code}`, code).
export const labels = define({
  es: {
    'state.draft': 'Borrador',
    'state.in_review': 'En revisión',
    'state.changes_requested': 'Cambios pedidos',
    'state.approved': 'Aprobada',
    'state.rejected': 'Rechazada',
    'state.discarded': 'Descartada',
    'state.superseded': 'Sustituida',
    'state.scheduled': 'Programada',
    'state.preparing': 'Preparando',
    'state.ready': 'Lista',
    'state.publishing': 'Publicando',
    'state.awaiting_reapproval': 'Pendiente de confirmar',
    'state.on_hold': 'En espera',
    'state.published': 'Publicada',
    'state.cancelled': 'Cancelada',
    'state.failed': 'Fallida',
    'state.needs_person': 'Necesita a una persona',

    'network.instagram': 'Instagram',
    'network.facebook': 'Facebook',
    'network.youtube': 'YouTube',
    'network.tiktok': 'TikTok',
    'network.linkedin': 'LinkedIn',
    'network.x': 'X',
    'network.threads': 'Threads',
    'network.pinterest': 'Pinterest',
    'network.bluesky': 'Bluesky',

    'role.admin': 'Administrador',
    'role.approver': 'Aprobador',
    'role.reviewer': 'Revisor',
    'role.producer': 'Productor',
    'role.reader': 'Lector',

    'kind.video': 'Vídeo',
    'kind.carousel': 'Carrusel',
    'kind.post': 'Post',
    'kind.story': 'Story',
    'kind.pdf': 'Documento PDF',

    'visibility.public': 'Visible',
    'visibility.private': 'Privada',
    'visibility.processing': 'Procesando',
    'visibility.scheduled': 'Retenida por la red',
    'visibility.unknown': 'No encontrada',

    'step.prepare': 'Preparar',
    'step.publish': 'Publicar',
    'step.verify': 'Comprobar que está publicada',
    'step.discard': 'Retirar',

    'errorClass.auth': 'Problema de conexión',
    'errorClass.rate_limit': 'Límite de la red',
    'errorClass.file_rejected': 'Rechazado por la red',
    'errorClass.transient': 'Fallo temporal',
    'errorClass.unsupported': 'No admitido',
    'errorClass.missed_window': 'Se pasó su hora',
    'errorClass.unknown': 'Error desconocido',

    'outcome.uploaded': 'Subió una versión nueva',
    'outcome.needs_people': 'Lo dejó a las personas',
    'outcome.failed': 'Falló',
    'outcome.checks_failed': 'No pasó las comprobaciones',
    'outcome.timeout': 'Se quedó sin tiempo',
    'outcome.aborted': 'Se detuvo',
    'outcome.blocked': 'No arrancó',

    'blockReason.budget_not_set': 'Sin presupuesto',
    'blockReason.rounds_exhausted': 'Rondas agotadas',
    'blockReason.piece_budget_reached': 'Presupuesto de la pieza agotado',
    'blockReason.monthly_budget_reached': 'Presupuesto del mes agotado',

    'trigger.version.changes_requested': 'Cambios pedidos',
    'trigger.slot.needs_content': 'Hueco vacío',

    'event.version.changes_requested': 'Cambios pedidos',
    'event.version.approved': 'Versión aprobada',
    'event.version.rejected': 'Versión rechazada',
    'event.comment.created': 'Comentario',
    'event.slot.needs_content': 'Hueco sin contenido',
    'event.publication.published': 'Publicación hecha',
    'event.publication.failed': 'Publicación fallida',
    'event.ping': 'Prueba',
  },
  en: {
    'state.draft': 'Draft',
    'state.in_review': 'In review',
    'state.changes_requested': 'Changes requested',
    'state.approved': 'Approved',
    'state.rejected': 'Rejected',
    'state.discarded': 'Discarded',
    'state.superseded': 'Superseded',
    'state.scheduled': 'Scheduled',
    'state.preparing': 'Preparing',
    'state.ready': 'Ready',
    'state.publishing': 'Publishing',
    'state.awaiting_reapproval': 'Awaiting confirmation',
    'state.on_hold': 'On hold',
    'state.published': 'Published',
    'state.cancelled': 'Cancelled',
    'state.failed': 'Failed',
    'state.needs_person': 'Needs a person',

    'network.instagram': 'Instagram',
    'network.facebook': 'Facebook',
    'network.youtube': 'YouTube',
    'network.tiktok': 'TikTok',
    'network.linkedin': 'LinkedIn',
    'network.x': 'X',
    'network.threads': 'Threads',
    'network.pinterest': 'Pinterest',
    'network.bluesky': 'Bluesky',

    'role.admin': 'Admin',
    'role.approver': 'Approver',
    'role.reviewer': 'Reviewer',
    'role.producer': 'Producer',
    'role.reader': 'Reader',

    'kind.video': 'Video',
    'kind.carousel': 'Carousel',
    'kind.post': 'Post',
    'kind.story': 'Story',
    'kind.pdf': 'PDF document',

    'visibility.public': 'Live',
    'visibility.private': 'Private',
    'visibility.processing': 'Processing',
    'visibility.scheduled': 'Held by the network',
    'visibility.unknown': 'Not found',

    'step.prepare': 'Prepare',
    'step.publish': 'Publish',
    'step.verify': 'Check it is live',
    'step.discard': 'Take down',

    'errorClass.auth': 'Connection problem',
    'errorClass.rate_limit': 'Network limit',
    'errorClass.file_rejected': 'Refused by the network',
    'errorClass.transient': 'Temporary failure',
    'errorClass.unsupported': 'Not supported',
    'errorClass.missed_window': 'Missed its hour',
    'errorClass.unknown': 'Unknown error',

    'outcome.uploaded': 'Sent a new version',
    'outcome.needs_people': 'Left it to people',
    'outcome.failed': 'Failed',
    'outcome.checks_failed': 'Did not pass the checks',
    'outcome.timeout': 'Ran out of time',
    'outcome.aborted': 'Stopped',
    'outcome.blocked': 'Not started',

    'blockReason.budget_not_set': 'No budget set',
    'blockReason.rounds_exhausted': 'Rounds used up',
    'blockReason.piece_budget_reached': 'Piece budget reached',
    'blockReason.monthly_budget_reached': 'Monthly budget reached',

    'trigger.version.changes_requested': 'Changes requested',
    'trigger.slot.needs_content': 'Empty slot',

    'event.version.changes_requested': 'Changes requested',
    'event.version.approved': 'Version approved',
    'event.version.rejected': 'Version rejected',
    'event.comment.created': 'Comment',
    'event.slot.needs_content': 'Slot needs content',
    'event.publication.published': 'Post published',
    'event.publication.failed': 'Post failed',
    'event.ping': 'Test',
  },
});
